import React from "react"

import { ContentTag } from "scrivito"
import { getUserColor } from "shared/lib/user/getUserColor"
import { getUserInitials } from "shared/lib/user/getUserInitials"
import { UserInfo } from "shared/types/UserInfo"
import { TextAvatar } from "shared/ui/text-avatar/TextAvatar"

import { MyProfileCardHeaderWidgetInstance } from "../MyProfileCardHeaderWidgetClass"
import { MyProfileCardActionsMenu } from "./MyProfileCardActionsMenu"

export interface MyProfileCardHeaderWidgetViewModel {
  widget: MyProfileCardHeaderWidgetInstance
  user: UserInfo | null | undefined
  onDeleteProfile: () => void
}

export const MyProfileCardHeaderWidgetView = React.memo(
  ({ user, widget, onDeleteProfile }: MyProfileCardHeaderWidgetViewModel) => {
    return (
      <div className="my-profile-card-header-widget">
        <div className="my-profile-card-header-widget__title">
          {user ? (
            <div className="my-profile-card-header-widget__text-avatar">
              <TextAvatar
                key={user.id}
                className="text-avatar--large"
                initials={getUserInitials({
                  name: user.name,
                  email: user.email || ""
                })}
                color={getUserColor(user.name || user.email)}
              />
            </div>
          ) : null}

          <ContentTag content={widget} attribute="content" />
        </div>

        <div className="my-profile-card-header-widget__actions">
          <MyProfileCardActionsMenu onDeleteProfile={onDeleteProfile} />
        </div>
      </div>
    )
  }
)
